import { Component, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AccountService } from '../../../services/account.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Api } from '../../../services/api';

interface Contacto{
  item: number,
  nombre: string,
  telefono: string,
  correo: string,
  cargo: string
}

@Component({
  selector: 'app-com-manage',
  imports: [CommonModule, FormsModule],
  templateUrl: './com-manage.html',
  styleUrl: './com-manage.css'
})
export class ComManage implements OnInit, OnChanges{
  public data: Contacto [] = [];
  public accService = inject(AccountService);
  @Input() account: any; 
  public contactos: any[] = [];
  public oportunidades: any[] = [];
  public isLoading = false;

  private api = inject(Api);


  constructor(){
    this.data = this.accService.getTableData();
  }

  ngOnInit(): void {
    if (this.account) this.loadRelatedData();

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.data = this.accService.getTableData();
    console.log(this.data);

    if (changes['account'] && this.account) {
      this.loadRelatedData();
    }
  }


  loadRelatedData(): void {
    console.log('Cuenta recibida en ComManage:', this.account);
    if (!this.account?.cuenta_id) return;
    this.isLoading = true;

    console.log('🔍 Cargando datos relacionados para cuenta:', this.account.nombre_empresa);

    if (this.account.contactos?.length) {
      this.contactos = this.account.contactos.map((c: any, index: number) => ({
        item: index + 1,
        nombre: `${c.nombre} ${c.apellido}`,
        telefono: c.telefono,
        correo: c.email,
        cargo: c.cargo
      }));
    }

    this.api.getOportunitiesByAccount(this.account.cuenta_id).subscribe({
      next: (res: any) => {
        this.oportunidades = res || [];
        console.log('💼 Oportunidades cargadas:', this.oportunidades);
        this.isLoading = false;
      },
      error: (err) => {
        console.error('❌ Error al cargar oportunidades:', err);
        this.isLoading = false;
      }
    });
  }





}
